import { thunk, action } from "easy-peasy";

import { fetchQuery } from "utils/relay";
import { emptyProxyObject } from "utils/utils";

const ItemStore = {
  item: emptyProxyObject,
  items: [],

  clearItem: action((state) => {
    state.item = emptyProxyObject;
  }),

  clearItems: action((state) => {
    state.items = [];
  }),

  setItem: action((state, item) => {
    state.item = item;
  }),

  setItems: action((state, items) => {
    state.items = items;
  }),

  fetchItem: thunk((actions, { query, variables }) => {
    actions.clearItem();
    return fetchQuery(query, variables).then((itemWrapper) => {
      const key = Object.keys(itemWrapper)[0];
      actions.setItem(itemWrapper[key]);
    });
  }),

  fetchItems: thunk((actions, { query, variables }) => {
    actions.clearItems();
    return fetchQuery(query, variables).then((itemsWrapper) => {
      const key = Object.keys(itemsWrapper)[0];
      actions.setItems(itemsWrapper[key]);
    });
  }),
};

export default ItemStore;
